<template>
  <div class="container">
    <SimpleHeader />
    <div class="zfcz-contblock" v-if="!(czsubmit || czsuccess)">
      <div class="zfmoney">
        <div class="lineStructure">
          <div class="linecont txBox">
            <p class="txBox-money">充值金额</p>
            <div class="cashInput">
              <span>¥</span>
              <input
                type="number"
                :readonly="!!rechargeValue"
                placeholder-class="font-color"
                min="0"
                v-model="amount"
                onblur="this.value= this.value.match( /^\d{0,6}(\.\d{0,2})?$/g) ? this.value.match(/^\d{0,6}(\.\d{0,2})?$/g)[0] : ''"
                placeholder="请输入"
              />
            </div>
          </div>
        </div>

        <div class="remark linecont">
          <span class="remark-title">备注</span>
          <van-cell-group inset>
            <van-field
              v-model="remark"
              maxlength="50"
              rows="1"
              autosize
              label=""
              type="textarea"
              placeholder="请输入，不超过50字"
            />
          </van-cell-group>
        </div>
      </div>

      <div class="zfpz zfcz" v-if="false">
        <div class="zfpz-title zfcz-style"><span>充值方式</span></div>
        <div class="zfpz-checkblock">
          <div v-for="(item, index) in list" :key="index" @click="useWhichBank(index)">
            <img class="icon-logo" :src="item.logo" alt="" />
            <div class="zfpz-title czfs-title">
              <span>{{ item.payment_name }}</span
              ><span v-if="item.paymentCode == 'wallet'">（余额￥{{ item.balance }}）</span>
            </div>
            <!-- <img
              class="icon-check"
              v-if="item.check"
              src="https://x.jzbull.com/x_dsx_h5/icons/bank-check0.png"
              alt=""
            /> -->
            <div class="icon-check" v-if="item.check">
              <SvgIcon icon="icon-fuxuan" size="0.64rem" :color="theme.PerformanceSelectIconColor" />
            </div>
          </div>
        </div>
      </div>

      <!--普通支付-->
      <Pay :list="payList" @check="checkSelect"></Pay>
      <!--银行支付-->
      <PayAgree
        :show="showAgreePay"
        :list="bankInfo.bankList"
        :title-info="payTitleInfo"
        @check="checkAgreeSelect"
        @addBank="addBank"
      >
      </PayAgree>
      <div class="zfpz" v-if="payment_id == 3" style="margin-bottom: 10px">
        <div class="zfpz-title"><span>支付凭证</span><span>（最多3张）</span></div>
        <div class="zfpz-img">
          <div v-for="(item, index) in listImg" :key="index">
            <img class="imgcont" :src="item" alt="" />
            <img class="imgx" @click.stop="delImg(index)" src="https://x.jzbull.com/x_dsx_h5/icons/x0.png" alt="" />
          </div>
          <div class="jiatu" v-if="listImg.length < 3">
            <img class="imgjia" src="https://x.jzbull.com/x_dsx_h5/icons/jia0.png" alt="" />
            <van-uploader
              class="uploadfake"
              v-model="fileList"
              :after-read="afterRead"
              :multiple="isIOS()"
              :preview-image="false"
              :max-count="3"
            ></van-uploader>
          </div>
        </div>
      </div>
    </div>

    <div class="btnfooter fcontentCenter p-12px" v-if="!(czsubmit || czsuccess)">
      <van-button
        @click="btnYck"
        :loading="confirmLoading"
        color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)"
        round
        block
        type="primary"
        >确定</van-button
      >
    </div>

    <Empty
      :show="czsubmit"
      title="充值提交成功"
      :subTitle="submitTitle"
      btnTxt="返回"
      otherBtnTxt="查看详情"
      @go="toPageBack"
      @seedetail="seedetail"
      img="https://x.jzbull.com/x_dsx_h5/icons/bank-check0.png"
    />
    <Empty
      :show="czsuccess"
      title="充值成功"
      subTitle=""
      btnTxt="返回"
      @go="toPageBack"
      img="https://x.jzbull.com/x_dsx_h5/icons/bank-check0.png"
    />
  </div>
</template>
<script>
import SimpleHeader from '@/components/SimpleHeader'
import Pay from '@/components/pay/pay.vue'
import PayAgree from '@/components/pay/pay-agree.vue'
import usePage from '@/hooks/usePage'
import { reactive, ref, onMounted, computed } from 'vue'
import { toRefs } from '@vueuse/core'
import Empty from '../withdrawal/components/empty.vue'
import { depositPaymentList, rechargeDeposit, rechargeByIntegral } from '@/api/yck'
import { uploadApi } from '@/api/upload'
import { uploadStyleEnum } from '@/enum/uploadEnum'
// import { getLocal } from '@/common/js/utils'
import { Toast, Dialog } from '@vant/compat'
import wx from 'weixin-js-sdk'
import SvgIcon from '@/components/SvgIcon.vue'
import { useUserStore } from '@/store/user'
import { isIOS } from '@/utils/is'
import { useRoute } from 'vue-router'
import { projectRules } from '@/enum'
import { useAppStore } from '@/store/app'

export default {
  name: 'CZ',
  components: {
    SimpleHeader,
    Empty,
    SvgIcon,
    Pay,
    PayAgree
  },
  setup() {
    const confirmLoading = ref(false)
    const { activityId, rechargeValue } = useRoute().query
    const fileList = ref([])
    const { navigateBack, redirectTo } = usePage()
    const userStore = useUserStore()
    const userApp = useAppStore()
    const isInWxapp = computed(() => userApp.isInWxapp)
    const theme = computed(() => userStore.getTheme)
    const projectInfo = computed(() => userStore.getProjectInfo) //用户信息
    const isXygj = computed(() => projectInfo.value.projectRule == projectRules.xygj)
    const submitTitle = computed(() =>
      isXygj.value ? '待直属上级审核，如急用请联系直属上级' : '待项目方审核，如急用请联系项目方'
    )
    const state = reactive({
      amount: rechargeValue || '',
      remark: '',
      orderId: 0,
      czsuccess: false,
      payList: [], //支付列表
      bankInfo: {
        bankList: []
      }, //银行信息
      payTitleInfo: {
        show: true,
        title: '银行快捷支付',
        text: '添加新卡支付'
      }
    })

    const list = ref([])
    const czsubmit = ref(false)
    const showAgreePay = ref(false)
    const listImg = ref([])
    let payment_id = ref(-1)
    let bankId = ref(0)

    function toPageBack() {
      navigateBack()
    }

    function seedetail() {
      redirectTo('/yckaudit?orderId=' + state.orderId)
    }

    const afterRead = async res => {
      // res.status = 'uploading';
      // res.message = '上传中...'
      // console.log(fileList.value)
      let i = 0
      uploadImage(i)
      // res.message = '上传成功'
    }

    async function uploadImage(i) {
      let result = await uploadApi({ file: fileList.value[i].file, style: uploadStyleEnum.STYLE_PIC_STD })
      listImg.value.push(result.file_url.url)
      if (listImg.value.length > 3) {
        listImg.value.splice(2)
        fileList.value = [] // 清空fileList
        return
      }
      i = i + 1
      if (i < fileList.value.length && listImg.value.length < 3) {
        uploadImage(i)
      } else {
        fileList.value = [] // 清空fileList
      }
    }

    async function getList() {
      let res = await depositPaymentList({ activityId })
      let { list } = res
      list.forEach(e => {
        if (e && e.payment_id === 5) {
          //银行支付
          state.bankInfo = e
          showAgreePay.value = true
        }
        if (e && !e['isSelect']) {
          //银行支付
          e['isSelect'] = false
        }
      })
      //默认选中
      res.list[0].isSelect = true
      payment_id.value = res.list[0].payment_id
      if (state.bankInfo && state.bankInfo.bankList.length) {
        state.bankInfo.bankList.forEach(e => {
          if (e && !e['isSelect']) {
            e['isSelect'] = false
          }
        })
        if (payment_id.value === 5) {
          //默认选中银行卡
          state.bankInfo.bankList[0].isSelect = true
          bankId.value = state.bankInfo.bankList[0].bankId
        }
      }
      state.payList = res.list
    }

    function checkSelect(index) {
      if (payment_id.value == state.payList[index].payment_id) {
        return
      }
      payment_id.value = state.payList[index].payment_id
      for (let i = 0; i < state.payList.length; ++i) {
        if (i === index) {
          state.payList[i].isSelect = true
        } else {
          state.payList[i].isSelect = false
        }
      }

      if (state.bankInfo && state.bankInfo.bankList.length) {
        for (let i = 0; i < state.bankInfo.bankList.length; ++i) {
          if (state.bankInfo.bankList[i]) {
            state.bankInfo.bankList[i].isSelect = false
          }
        }
        bankId.value = 0
      }
    }

    function checkAgreeSelect(index) {
      if (bankId.value == state.bankInfo.bankList[index].bankId) {
        return
      }
      bankId.value = state.bankInfo.bankList[index].bankId
      if (state.bankInfo && state.bankInfo.bankList.length) {
        for (let i = 0; i < state.bankInfo.bankList.length; ++i) {
          if (i === index) {
            state.bankInfo.bankList[i].isSelect = true
          } else {
            state.bankInfo.bankList[i].isSelect = false
          }
        }
      }
      if (state.payList.length) {
        for (let i = 0; i < state.payList.length; ++i) {
          if (state.payList[i] && state.payList[i].payment_id === 5) {
            state.payList[i].isSelect = true
            payment_id.value = state.payList[i].payment_id
          } else {
            state.payList[i].isSelect = false
          }
        }
      }
    }

    async function btnYck() {
      if (!state.amount) {
        Toast('请输入金额')
        return
      }
      // if (!state.remark) {
      //   Toast('请输入备注')
      //   return
      // }

      if (payment_id.value == -1) {
        Toast('请选择充值方式')
        return
      }
      if (payment_id.value == 3 && listImg.value.length == 0) {
        Toast('请上传凭证')
        return
      }
      if (payment_id.value == 5 && bankId.value <= 0) {
        Toast('请选择银行卡')
        return
      }
      if (payment_id.value != 3) {
        listImg.value = []
      }

      let params = {
        amount: state.amount,
        remark: state.remark,
        payWay: payment_id.value,
        picContent: listImg.value,
        bankId: bankId.value || 0
      }

      if (payment_id.value === 6) {
        const resData = await rechargeByIntegral({ amount: state.amount, recharge_type: 'deposit' })
        if (resData) {
          Dialog.confirm({
            title: '提示',
            message: `本次兑换${userStore.getDepositName}${state.amount}元，共扣减${resData.consume_integral}${projectInfo.value.integralName}，确认是否需要充值？`,
            beforeClose: action =>
              new Promise(async resolve => {
                if (action === 'confirm') {
                  try {
                    let res = await rechargeDeposit(params)
                    state.orderId = res.orderId
                    resolve(true)
                  } catch {
                    resolve(false)
                  }
                } else {
                  resolve(true)
                }
              })
          })
            .then(() => {
              if (resData.is_verify) {
                czsubmit.value = true
              } else {
                state.czsuccess = true
              }
            })
            .catch(() => {})
        }
      } else {
        handelRecharge(params)
      }
    }

    async function handelRecharge(params) {
      try {
        confirmLoading.value = true
        let res = await rechargeDeposit(params)
        if (payment_id.value == 1 || payment_id.value == 5) {
          state.orderId = res.orderId
          if (!isInWxapp.value) {
            Toast.fail('该功能需要前往小程序查看')
            return
          }
          wx.miniProgram.redirectTo({ url: `/packageB/pages/pay/pay?orderId=${res.orderId}&sourceH5=true` })
        } else if (payment_id.value == 3) {
          state.orderId = res.orderId
          czsubmit.value = true
        } else {
          state.czsuccess = true
        }
      } finally {
        confirmLoading.value = false
      }
      // console.log(res)
    }

    function useWhichBank(index) {
      if (!list.value[index].check) {
        list.value.forEach(element => {
          element.check = false
        })
      }
      list.value[index].check = !list.value[index].check
      if (list.value[index].check) {
        payment_id.value = list.value[index].payment_id
      } else {
        payment_id.value = -1
      }
    }

    function addBank() {
      wx.miniProgram.navigateTo({ url: `/packageC/pages/bank/pages/addBank` })
    }

    function delImg(index) {
      this.listImg.splice(index, 1)
      this.fileList.splice(index, 1)
    }

    onMounted(() => {
      getList()
    })

    return {
      confirmLoading,
      rechargeValue,
      list,
      showAgreePay,
      bankId,
      payment_id,
      btnYck,
      listImg,
      useWhichBank,
      delImg,
      isIOS,
      czsubmit,
      afterRead,
      toPageBack,
      seedetail,
      ...toRefs(state),
      theme,
      checkSelect,
      checkAgreeSelect,
      addBank,
      fileList,
      submitTitle
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background: #fff;
  width: 100%;
  height: 100%;
  position: relative;
}

.zfcz-contblock {
  padding-top: 10px;
  padding-bottom: 50px;
}

.zfpz {
  width: 375px;
  height: 170px;
  opacity: 1;
  background: #ffffff;
  padding: 16px 20px;
  padding-right: 0;
  box-sizing: border-box;

  &-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    > span:nth-child(1) {
      color: #222;
      font-size: 16px;
    }

    > span:nth-child(2) {
      color: #999999;
      font-size: 16px;
    }
  }

  &-img {
    display: flex;
    align-items: center;

    .van-uploader__preview {
      width: 100px;
      height: 100px;
      background: #f5f6f7;
      margin-right: 12px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(.van-uploader__preview-image) {
      width: 100px !important;
      height: 100px !important;
    }

    .van-uploader__wrapper {
      > div {
        margin-right: 12px;
      }
    }

    .jiatu,
    > div {
      width: 100px;
      height: 100px;
      background: #f5f6f7;
      margin-right: 12px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .imgcont {
        flex: 1;
        width: 100px;
        height: 100px;
      }

      .imgx {
        position: absolute;
        width: 24px;
        height: 24px;
        top: -12px;
        right: -12px;
      }

      .imgjia {
        width: 36px;
        height: 36px;
      }
    }
  }
}

.zfcz-style {
  margin-bottom: 8px;
}

.icon-check {
  width: 24px;
  height: 24px;
}

.icon-logo {
  width: 36px;
  height: 36px;
  margin-right: 12px;
}

.zfpz-checkblock {
  padding: 0 15px;
  padding-left: 0;

  > div {
    border-bottom: 0.5px solid #dbdbdb;
    display: flex;
    align-items: center;

    &:last-child {
      border-bottom: 0;
      height: 60px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }

    .icon-check {
      width: 24px;
      height: 24px;
      margin-left: auto;
    }
  }
}

.czfs-title {
  height: 60px;
  margin-bottom: 0;
}

.zfcz {
  height: auto;
  margin: 10px 0;
}

.lineStructure {
  height: 119px;
}

.txBox {
  flex-direction: column !important;
  height: 119px !important;
  padding: 17px 0 9px !important;
  align-items: flex-start !important;

  &-money {
    margin-bottom: 10px;
    color: #222;
    line-height: 22px;
    font-size: 16px;
  }

  input::-webkit-input-placeholder {
    font-size: 14px;
    line-height: 40px !important;
  }
}

.cashInput {
  font-size: 40px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #222;
  overflow: hidden;
  position: relative;
  width: 100%;

  span {
    line-height: 48px;
    margin-right: 4px;
  }

  input {
    width: 70%;
    font-size: 40px;
    line-height: 44px;
    box-sizing: border-box;
  }
}

.zfmoney {
  width: 375px;
  min-height: 192px;
  box-sizing: border-box;
  padding: 0 15px;
  opacity: 1;
  background: #ffffff;

  .remark {
    border-top: 0.5px solid #dbdbdb;
    width: 345px;
    min-height: 84px;
    margin: 8px auto 0;
    padding-top: 16px;
    box-sizing: border-box;

    &-title {
      color: #222;
      line-height: 22px;
      font-size: 16px;
    }

    .van-cell-group::after {
      border-width: 0 !important;
    }

    .van-cell {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

.uploadfake {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
  opacity: 0;
}

:deep(.van-field__control) {
  word-break: break-all;
}

input::-webkit-input-placeholder {
  color: #d9d9d9;
  font-size: 14px;
  font-weight: normal;
}
</style>
